import template from './mobile_app.create.html';
import controller from './mobile_app.create.controller';
import './mobile_app.create.scss'

let mobileAppCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
};

export default mobileAppCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/create/mobile_app.create.component.js